module.exports = __webpack_public_path__ + "static/media/logopolisi-temporary.e43e7853.jpg";